export default "__VITE_ASSET__ed3ea37f__"